module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAABLUlEQVQoU3XQvUsCcRjA8e9zZQoiCEEQTQ0RNQVC3RkVNPSCd2Z/QDQHQVO0REiDNPcPCEEuTXJGk3AteTg0NLQGLUHQUkGC9ntCoxKlZ3t4PjxvQk/oTC5JrLUHUpfQv+ouS3ei82uTmEgZNAaMgRaoXeYFtO1+sdreOkIJuMaSLZRFjDkHqfL6ti33wXsHq+PugxRQPSGsHP10UjszBVYZ+IDmhqjj7gKnqBxK6Bf6bkivjKDRW9BB0dTqKENDeZRpCf0Fnd0cxmoWEYkDxxiNY1HC4H6vYXsHQE5C31HHWwIC4BmlCOYGkTOpVZL9eM6dwOIOJMonO1jm6V/cmZRKRUgkBiQIGmpnsj04kwXrAuGx90AggfLQXvHvz2lvGWW8D6tpYRoVqVdfvgDm0nbViRz5RAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/redHomeIcon.png
// module id = D9yh
// module chunks = 3